module.exports = __webpack_public_path__ + "img/icon-url.3fcd2f8c.svg";